import * as React from 'react';

import FilterColumn from './filter_column';
import { Activity, Topic } from './interfaces';

import useModalAccessibility from '../../../../../Shared/hooks/useModalAccessibility';

const closeIconSrc = `${window.postbuildEnv.CDN_URL}/images/icons/close.svg`

interface MobileFilterMenuProps {
  activities: Activity[],
  filteredActivities: Activity[],
  calculateNumberOfFilters: () => number,
  resetAllFilters: () => void,
  activityClassificationFilters: string[],
  handleActivityClassificationFilterChange: (activityClassificationFilters: string[]) => void,
  targetGradeRangeFilters: string[],
  handleTargetGradeRangeFilterChange: (targetGradeRangeFilters: string[]) => void,
  ellFilters: number[],
  handleELLFilterChange: (ellFilters: number[]) => void,
  activityFocusFilters: number[],
  handleActivityFocusFilterChange: (activityFocusFilters: number[]) => void,
  filterActivities: (ignoredKey?: string) => Activity[],
  setShowMobileFilterMenu: (show: boolean) => void,
  showMobileFilterMenu: boolean,
  contentPartnerFilters: number[],
  handleContentPartnerFilterChange: (contentPartnerFilters: number[]) => void,
  earlyAccessFilters: string[],
  handleEarlyAccessFilterChange: (earlyAccessFilters: string[]) => void,
  topicFilters: number[],
  handleTopicFilterChange: (topicFilters: number[]) => void,
  savedActivityFilters: number[],
  handleSavedActivityFilterChange: () => void,
  savedActivityIds: number[],
  flagFilters: string[],
  handleFlagFilterChange: () => void,
  typingRequirementFilters: string[],
  handleTypingRequirementFilterChange: () => void,
  flagset: string,
  isStaff?: boolean,
  topics: Topic[],
}

const MobileFilterMenu = ({
  activities,
  activityFocusFilters,
  activityClassificationFilters,
  calculateNumberOfFilters,
  contentPartnerFilters,
  handleContentPartnerFilterChange,
  filterActivities,
  filteredActivities,
  ellFilters,
  targetGradeRangeFilters,
  handleActivityFocusFilterChange,
  handleActivityClassificationFilterChange,
  handleTargetGradeRangeFilterChange,
  handleELLFilterChange,
  topicFilters,
  handleTopicFilterChange,
  resetAllFilters,
  showMobileFilterMenu,
  setShowMobileFilterMenu,
  savedActivityFilters,
  handleSavedActivityFilterChange,
  savedActivityIds,
  isStaff,
  flagFilters,
  handleFlagFilterChange,
  earlyAccessFilters,
  handleEarlyAccessFilterChange,
  typingRequirementFilters,
  handleTypingRequirementFilterChange,
  flagset,
  topics,
}: MobileFilterMenuProps) => {
  function closeMobileFilterMenu() { setShowMobileFilterMenu(false) }

  // Treat this menu as a modal at narrow viewports / zoomed views: trap focus
  // inside it, close on ESC, and restore focus to the trigger button on close.
  // The hook must run before the early return below to satisfy rules-of-hooks,
  // so we gate its effects with the `showMobileFilterMenu` flag.
  const { modalRef } = useModalAccessibility(closeMobileFilterMenu, showMobileFilterMenu);

  if (!showMobileFilterMenu) { return <span /> }

  const filterColumnProps = {
    activities,
    activityFocusFilters,
    activityClassificationFilters,
    calculateNumberOfFilters,
    contentPartnerFilters,
    filterActivities,
    filteredActivities,
    ellFilters,
    targetGradeRangeFilters,
    handleActivityFocusFilterChange,
    handleELLFilterChange,
    handleActivityClassificationFilterChange,
    handleContentPartnerFilterChange,
    handleTargetGradeRangeFilterChange,
    resetAllFilters,
    topicFilters,
    handleTopicFilterChange,
    savedActivityFilters,
    handleSavedActivityFilterChange,
    savedActivityIds,
    handleFlagFilterChange,
    flagFilters,
    isStaff,
    earlyAccessFilters,
    handleEarlyAccessFilterChange,
    typingRequirementFilters,
    handleTypingRequirementFilterChange,
    flagset,
    topics,
  }

  return (
    <section
      aria-label="Filter activities"
      aria-modal="true"
      className="mobile-filter-menu"
      ref={modalRef}
      role="dialog"
      tabIndex={-1}
    >
      <div className="top-section">
        <button className="interactive-wrapper focus-on-light" onClick={closeMobileFilterMenu} type="button">
          <img alt="Close icon" src={closeIconSrc} />
        Close
        </button>
      </div>
      <FilterColumn
        {...filterColumnProps}
      />
      <button className="quill-button-archived primary contained medium focus-on-light" onClick={closeMobileFilterMenu} type="button">
      Apply
      </button>
    </section>
  )
}

export default MobileFilterMenu
